import fieldsForStipsForm from './fieldsForStipsForm';

// The label used as `file.tag` for a driver's license. This exact string is the
// identity across three places: the dropdown value below, `field.display` in
// fieldsForStipsForm, and the stip `name` underwriting returns.
export const DRIVERS_LICENSE_TAG = 'Drivers License';

export const OTHER_TAG = 'Other';

export const stipUploadTags = [
  {label: DRIVERS_LICENSE_TAG, value: DRIVERS_LICENSE_TAG},
  {label: 'Proof of Ownership', value: 'Proof of Ownership'},
  {label: 'Month to Date', value: 'Month to Date'},
  {label: 'Voided Check', value: 'Voided Check'},
  {label: 'Accounts Receivable Report/Invoices', value: 'Accounts Receivable Report/Invoices'},
  {label: 'Balance Sheet & Income Statement', value: 'Balance Sheet & Income Statement'},
  {label: 'Balance Sheet', value: 'Balance Sheet'},
  {label: 'Payback Months', value: 'Payback Months'},
  {label: 'Tax Return', value: 'Tax Return'},
  {label: 'Tax Guard', value: 'Tax Guard'},
  {label: OTHER_TAG, value: OTHER_TAG}
];

export const signedApplicationTag = {label: 'Signed Application', value: 'Signed Application'};

export const bankStatementsTag = {label: 'Bank Statements', value: 'Bank Statements'};

export const signedContractsTag = {label: 'Signed Contracts', value: 'Signed Contracts'};

// Labels the portal might send as `file.tag` that aren't defined as upload-form
// fields in `fieldsForStipsForm.js`. The form definitions are the source of
// truth for everything else — each `uploadStips` entry already pairs `display`
// (label) with `modelVal` (snake_case key matching underwriting's
// `Attachment::DOCUMENT_TAGS`). This dict just fills the gaps for tags that
// live elsewhere (the file-tagger dropdown extras, signed application/contracts
// from new-submission, and the plural "Bank Statements" spelling).
const SUPPLEMENTARY_TAG_KEYS = {
  'Balance Sheet & Income Statement': 'balance_sheet_income_statement',
  'Other': 'other',
  'Signed Application': 'signed_application',
  'Bank Statement': 'bank_statement',
  'Bank Statements': 'bank_statement'
};

const tagKeyByDisplay = fieldsForStipsForm.uploadStips
  .filter(f => f.modelVal)
  .reduce((acc, f) => {
    acc[f.display] = f.modelVal;
    return acc;
  }, {});

// Returns the snake_case symbol-key form of a stip label, mirroring
// underwriting's `Attachment::DOCUMENT_TAGS.keys`. Falls back to the label
// unchanged if we don't have a mapping — preserves the round-trip for custom
// stip names underwriting may return that the portal doesn't statically know
// about, rather than silently dropping them.
export function documentTagKeyFor(label) {
  return tagKeyByDisplay[label] || SUPPLEMENTARY_TAG_KEYS[label] || label;
}
